"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tezze-sul-brenta": {
    "2d96e462": [{
      "hkey": "7f216df6",
      "slug": "belvedere-cusinati",
      "name": "Belvedere-Cusinati",
      "primary": true,
      "skipSearch": false
    }],
    "belvedere": [{
      "hkey": "7f216df6",
      "slug": "belvedere-cusinati",
      "name": "Belvedere-Cusinati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9394b77e": [{
      "hkey": "7f216df6",
      "slug": "belvedere-cusinati",
      "name": "Belvedere-Cusinati",
      "primary": true,
      "skipSearch": false
    }],
    "cusinati": [{
      "hkey": "7f216df6",
      "slug": "belvedere-cusinati",
      "name": "Belvedere-Cusinati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tezze-sul-brenta"
    }]
  }
};
exports["default"] = _default;